query getChildCompaniesWithLocation($parentId: ID) {
  childCompaniesWithLocation(parentId: $parentId) {
    id
    name
    state
    city
    ambassador {
      firstname
      lastname
    }
  }
}
